@if (item) {
  <div class="card detail-header-card mb-5">
    <div class="card-content">
      <div class="columns">
        <div class="column detail-meta">
          <div class="mb-3">
            <span
              class="status-dot"
              [ngClass]="{
                'is-success': item.status === 'published',
                'is-warning': item.status === 'pending_review',
                'is-danger': item.status === 'draft' && item.rejectReason,
                'is-light': item.status === 'draft' && !item.rejectReason,
                'is-info': item.status === 'unchanged'
              }"
            ></span>
          </div>
          <p class="org-name">Organization: <strong>{{ item.organizationName || item.createdByName || '-' }}{{ item.country ? ' (' + item.country + ')' : '' }}</strong></p>
          <p>Submitter: {{ item.createdByName }} ({{ item.createdByEmail }})</p>
          <p>Current section: <strong>{{ item.currentSection }}</strong> <span class="status-label" [ngClass]="{
                'is-success': item.status === 'published',
                'is-warning': item.status === 'pending_review',
                'is-danger': item.status === 'draft' && item.rejectReason,
                'is-light': item.status === 'draft' && !item.rejectReason,
                'is-info': item.status === 'unchanged'
              }">({{ statusLabel }})</span></p>
          <p>Submitted at: <strong>{{ item.updatedAt | date:'MMM d, y, hh:mm a z' }}</strong></p>
          <p>Created at: <strong>{{ item.createdAt | date:'MMM d, y, hh:mm a z' }}</strong></p>
          <p>Reporting Period: <strong>{{ item.reportingPeriodLabel }}</strong> ({{ item.versionKey }})</p>
        </div>

        <div class="column is-narrow has-text-right">
          <div class="detail-actions">
            <button class="button is-outlined" [class.is-warning]="!isPubliclyVisible" [class.is-loading]="isDownloadingPdf" [disabled]="isDownloadingPdf" (click)="downloadPdf()">
              <span class="icon is-small">
                <i aria-hidden="true" class="icon icon-download"></i>
              </span>
              <span>{{ pdfButtonLabel }}</span>
            </button>
            <ng-container *caseHasPermission="{ requireOr: ['deleteTransparencyReports', 'deleteOwnTransparencyReports'] }">
              <a class="button is-outlined" [caseAction]="deleteAction">
                <span class="icon is-small">
                  <i aria-hidden="true" class="icon icon-x"></i>
                </span>
                <span>Delete</span>
              </a>
            </ng-container>
            @if (item.status === 'published') {
              <ng-container *caseHasPermission="'reviewTransparencyReports'">
                <a class="button is-dark" (click)="changeStatus('pending_review')">
                  <span class="icon is-small">
                    <i aria-hidden="true" class="icon icon-file-text"></i>
                  </span>
                  <span>Unlist</span>
                </a>
              </ng-container>
            }
            @if (item.status === 'pending_review') {
              <ng-container *caseHasPermission="'reviewTransparencyReports'">
                <a class="button is-success" (click)="changeStatus('published')">
                  <span class="icon is-small">
                    <i aria-hidden="true" class="icon icon-file-text"></i>
                  </span>
                  <span>Publish</span>
                </a>
                <a class="button is-danger" [caseAction]="rejectAction">
                  <span class="icon is-small">
                    <i aria-hidden="true" class="icon icon-file-text"></i>
                  </span>
                  <span>Reject</span>
                </a>
              </ng-container>
            }
          </div>
          <img src="assets/images/HAIP.png" class="haip-logo" alt="HAIP Reporting Framework" />
        </div>
      </div>
    </div>
  </div>

  @if (item.rejectReason) {
    <article class="message is-danger mb-5">
      <div class="message-body">
        <p><strong>This transparency report has been rejected</strong></p>
        <p>{{ item.rejectReason }}</p>
      </div>
    </article>
  }

  @if (questionnaire.length) {
    <app-questionnaire-review
      [questionnaire]="questionnaire"
      [submission]="item"
      [readOnly]="true"
      [hideHeader]="true"
    />
  }
}
